export enum DataChannels {
  MessageReceived = 'MessageReceived',
  ErrorReceived = 'ErrorReceived',
  WebSocketClosed = 'WebSocketClosed',
  GameCreated = 'GameCreated',
  GameRetrieved = 'GameRetrieved',
  GameUpdated = 'GameUpdated',
  LatestGame = 'LatestGame'
}
